import React, { useEffect, useState, useRef } from 'react'
import cssLanguageNotesVocabulary from './LanguageNotesVocabulary.module.scss'
import Card from '../../LUUtils/Card/Card';
import { CardBackgroundEnum } from '../../LUUtils/Card/Card';
import { GoToLUSinceActionEnum } from '../../LearningUnit.js';
// import GoogleShareToClassRoom from '../../../Utils/GShare.js'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "LanguageNotesVocabulary"
const INDEX_NONE = -1 // 未播放
// #endregion Constant

// #region Enumeration
const PlayModeEnum = {
    None: 0,
    Loading: 1,
    Playing: 2,
    Paused: 3,
    Stop: 4
}

const ScrollButtonEnum = {
    Top: 1,
    More: 2
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false // true:第一次進入此Component false:再次render 非第一次進入次Component
let mintStateCurrentPageIndex = 0 // Index of SubCategory, ListOfContent, SuperQuestion or IlluContents
let mintTotalPages = 0 // 此LU內 若有Multiple Page 則 在此紀錄共有幾個Page
let mintChangeAnimationType = 0 // 0:window.gChangeAnimationTypeEnum.None, 決定Card動畫是 由左而右 或 由右而左
let mstrLUCatSeqNo = "" // LUType
let mstrBookCatID = ""
// #endregion Member Variables

function LanguageNotesVocabulary(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [playMode, setPlayMode] = useState(PlayModeEnum.Stop)
    const [currentAudioPlayingIndex, setCurrentAudioPlayingIndex] = useState(INDEX_NONE)
    const [showScrollButton, setShowScrollButton] = useState(false) // Top/More按鈕是否顯示
    const [scrollButtonType, setScrollButtonType] = useState(ScrollButtonEnum.More) // 要顯示Top或More
    const [currentPageIndex, setCurrentPageIndex] = useState(0)
    // #endregion Init State

    // #region Init Ref
    let mrefScrollArea = useRef(null)
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".mblnInitialized: ", mblnInitialized)
        mblnInitialized = true
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo
        mintTotalPages = props.LUInfo.SubCategory.length
        console.log("mintTotalPages: ", mintTotalPages)
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)

        // 第一次進入LU時 判斷是用點擊/上一頁/下一頁進來的 而給予不同的<Card />動畫
        switch (props.GoToLUSinceAction)
        {
            case GoToLUSinceActionEnum.Default:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.None
                console.log("Default.mintTotalPages: ", mintTotalPages)
                setCurrentPageIndex(0)
                break;
            case GoToLUSinceActionEnum.GoPrev:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.Prev
                console.log("GoPrev.mintTotalPages: ", mintTotalPages)
                setCurrentPageIndex(mintTotalPages - 1)
                break;
            case GoToLUSinceActionEnum.GoNext:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.Next
                console.log("GoNext.mintTotalPages: ", mintTotalPages)
                setCurrentPageIndex(0)
                break;
            default:
                break;
        }
    }
    // #endregion First Launch

    // #region useEffect

    useEffect(() => {
        mintStateCurrentPageIndex = currentPageIndex
    }, [currentPageIndex])

    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        mrefPaintedMe.current()
        
        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")
        
        // window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        // window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        GlobalLibs.AddWindowOnResizeWindow(WindowOnResizeEventHandler, COMP_NAME)
        RegisterAudioEvent()

        // 註冊Multiple Page中的上/下一頁事件
        let objCallbackData = {
            "Action": "InitCalledInfoInMultiPagedLU",
            "NextOnTapHandlerRef": LUNextPageHandler,
            "PrevOnTapHandlerRef": LUPrevPageHandler,
            "CanBePrev": (mintStateCurrentPageIndex > 0), // Multiple Page 非第一頁才為ture 
            "CanBeNext": (mintStateCurrentPageIndex < mintTotalPages - 1) // Multiple Page 非最後一頁才會true
        }
        props.CallbackRef(objCallbackData)

        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()

        // 判斷是否顯示 Top/More
        SetScrollToTopOrMoreButton()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")
        mblnInitialized = false
        GlobalLibs.RemoveWindowOnResizeWindow(COMP_NAME)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.StopAudio()
        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()
    }
    // #endregion Painted Me

    // #region OnTapHandler
    function PlayOneAudioOnTapHandler(SubCategoryIndex, Index)
    {
        console.log(COMP_NAME + ".PlayOneAudioOnTapHandler:", SubCategoryIndex, Index)
        console.log("playMode: ", playMode)

        let strAudioFN = props.LUInfo.SubCategory[SubCategoryIndex].Sentence[Index].AudioFN
        // console.log("strAudioFN: ", strAudioFN)
        let strAudioUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, strAudioFN);
        console.log("strAudioUrl: ", strAudioUrl)
        window.AudioLibs.PlayAudio(strAudioUrl)

        setCurrentAudioPlayingIndex(Index)
        setPlayMode(PlayModeEnum.Loading)
    }

    function ScrollAreaScrollToTopOrMoreOnTapHandler()
    {
        console.log(COMP_NAME + ".ScrollAreaScrollToTopOrMoreOnTapHandler: ")
        if (
            (typeof(mrefScrollArea.current) !== "undefined") &&
            (mrefScrollArea.current !== null)
            )
        {
            let intScrollHeight = mrefScrollArea.current.scrollHeight; // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
            let intScrollWidth = mrefScrollArea.current.scrollWidth; // scrollWidth
            let intScrollLeft = mrefScrollArea.current.scrollLeft; // scrollLeft
            let intScrollTop = mrefScrollArea.current.scrollTop; // scrollTop

            console.log("intScrollHeight:", intScrollHeight)
            console.log("intScrollWidth:", intScrollWidth)
            console.log("intScrollLeft:", intScrollLeft)
            console.log("intScrollTop:", intScrollTop)

            let intClientHeight = mrefScrollArea.current.clientHeight; // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
            let intClientWidth = mrefScrollArea.current.clientWidth; // clientWidth Ref: 
            let intClientTop = mrefScrollArea.current.clientTop; // clientTop
            let intClientLeft = mrefScrollArea.current.clientLeft; // clientLeft

            console.log("intClientHeight:", intClientHeight)
            console.log("intClientWidth:", intClientWidth)
            console.log("intClientTop:", intClientTop)
            console.log("intClientLeft:", intClientLeft)

            // let intScrollTop = mrefScrollArea.current.scrollTop;
            // let intClientHeight = mrefScrollArea.current.clientHeight;
            // let intScrollHeight = mrefScrollArea.current.scrollHeight;

            // +1 是避免有小數點的誤差
            if (intScrollTop + intClientHeight + 1 >= intScrollHeight )
            {
                console.log("ScrollAreaScrollToTopOrMoreOnTapHandler: Scroll已在最底")
                // 如果現在是在Scroll的最底端 則回到最Top
                // Scroll To Top
                // mrefScrollArea.current.scrollTo({ 
                //     top: 0, 
                //     behavior: "smooth" 
                // });
                GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, 0, 0, 300)
            }
            else
            {
                console.log("ScrollAreaScrollToTopOrMoreOnTapHandler: Scroll未在最底")
                // 如果未到底 就向下移動 (clientHeight / 2) 如果已到最底 則不動
                // Scroll To Somewhere
                let intScrollTo = mrefScrollArea.current.scrollTop + ((intScrollTop + intClientHeight !== intScrollHeight) ? (intClientHeight/ 2) : 0)
                // mrefScrollArea.current.scrollTo({ 
                //     top: intScrollTo, 
                //     behavior: "smooth" 
                // });

                GlobalLibs.ExecuteScrollBy(mrefScrollArea.current, intScrollTo, 0, 300)
            }
        }
    }
    // #endregion OnTapHandler

    // #region Other Handler
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")
    }

    function WindowOnResizeEventHandler()
    {
        console.log(COMP_NAME + ".WindowOnResizeEventHandler")

        SetScrollToTopOrMoreButton()
    }

    // #region Audio Event
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler");
        setCurrentAudioPlayingIndex(INDEX_NONE)
        setPlayMode(PlayModeEnum.Stop)
    }

    function PlayAudioCanPlayHandler()
    {
        console.log(COMP_NAME + ".PlayAudioCanPlayHandler");
        setPlayMode(PlayModeEnum.Playing)
    }
    // #endregion Audio Event

    // #endregion Other Handler

    // #region Toast
    // #endregion Toast

    // #region LoadingMask and Alert
    // function OpenLoadingMask(LoadingMsg)
    // {
    //     console.log("OpenLoadingMask: ", LoadingMsg)

    //     let objCallbackData = {
    //         "Action": "OpenLoadingMask",
    //         "Message": LoadingMsg
    //     }
    //     props.CallbackRef(objCallbackData)
    // }

    // function CloseLoadingMask()
    // {
    //     console.log(COMP_NAME + ".CloseLoadingMask")

    //     let objCallbackData = {
    //         "Action": "CloseLoadingMask"
    //     }
    //     props.CallbackRef(objCallbackData)
    // }
    // #endregion LoadingMask and Alert

    // #region Component Callback
    function CardCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".CardCallback", CallbackObj)

        if (CallbackObj.Action === "ComponentDidUpdate")
        {
            SetScrollToTopOrMoreButton()
        }
    }

    function GlossaryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary")
        {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            RegisterAudioEvent() // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }
    // #endregion Component Callback

    // #region Alert Callback
    // #endregion Alert Callback

    // #region Other Functions

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }

    function RegisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    } 

    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }

    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/15 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL;
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置

        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler

    // #region LU Change page within multiple page
    function LUPrevPageHandler()
    {
        console.log(COMP_NAME + ".LUPrevPageHandler: ")

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("mintTotalPages: ", mintTotalPages)

        StopAudioAndResetPlayingIndex()

        if (mintStateCurrentPageIndex > 0)
        {
            // 目前在Multiple Page中 的非第一頁 點擊上一頁
            console.log("Prev is clicked, let's go to Prev page")
            mintChangeAnimationType = window.gChangeAnimationTypeEnum.Prev // 動畫新的畫面 由右往左出現
            // mintCurrentPageIndex--
            let intPageIndex = mintStateCurrentPageIndex - 1
            setCurrentPageIndex(intPageIndex)

            let objCallbackData = {
                "Action": "UpdateCanBeNavigatedInMultiPagedLU",
                "CanBePrev": (intPageIndex > 0),
                "CanBeNext": (intPageIndex < mintTotalPages - 1)
            }
            props.CallbackRef(objCallbackData)

            ScrollToTop()
        }
        else
        {
            // richard: 20211110 因為有 CanBeNext, parent 加判斷就不會發生
            // LU內有Multiple Page中 已在第一頁時 點擊上一頁
            console.log("Prev is clicked in the 1st page, let's inform parent")
            console.log("不應該發生")
        }
    }

    function LUNextPageHandler()
    {
        console.log(COMP_NAME + ".LUNextPageHandler: ")

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("mintTotalPages: ", mintTotalPages)

        StopAudioAndResetPlayingIndex()

        if (mintStateCurrentPageIndex < mintTotalPages - 1)
        {
            // LU內有Multiple Page 在非最後一頁時 點擊下一頁
            console.log("Next is clicked, let's go to next page")
            mintChangeAnimationType = window.gChangeAnimationTypeEnum.Next // 動畫新的畫面 由左往右出現
            // mintCurrentPageIndex++
            let intPageIndex = mintStateCurrentPageIndex + 1
            setCurrentPageIndex(intPageIndex)

            let objCallbackData = {
                "Action": "UpdateCanBeNavigatedInMultiPagedLU",
                "CanBePrev": (intPageIndex > 0),
                "CanBeNext": (intPageIndex < mintTotalPages - 1)
            }
            props.CallbackRef(objCallbackData)

            ScrollToTop()
        }
        else
        {
            // richard: 20211110 因為有 CanBeNext, parent 加判斷就不會發生
            console.log("Next is clicked in the last page, let's inform parent")
            console.log("不應該發生")
        }
    }

    // #endregion LU Change page within multiple page

    function GetSubCategoryName(SubCategoryIndex)
    {
        console.log(COMP_NAME + ".GetSubCategoryName", SubCategoryIndex);

        let strSubCategoryName = ""
        if ((window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major))
        {
            strSubCategoryName = props.LUInfo.SubCategory[SubCategoryIndex].MajorName
        }
        else
        {
            strSubCategoryName = props.LUInfo.SubCategory[SubCategoryIndex].MinorName
        }
        return strSubCategoryName
    }

    function GetSubCategorySentenceText(SubCategoryIndex, Index)
    {
        console.log(COMP_NAME + ".GetSubCategorySentenceText: ", SubCategoryIndex, Index);
        
        let strText = ""
        if ((window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major))
        {
            // console.log("GetSubCategorySentenceText.MajorText")
            strText = props.LUInfo.SubCategory[SubCategoryIndex].Sentence[Index].MajorText
        }
        else
        {
            // console.log("GetSubCategorySentenceText.MinorText")
            strText = props.LUInfo.SubCategory[SubCategoryIndex].Sentence[Index].MinorText
        }
        return strText
    }

    function ScrollAreaScrollEventHandler(e)
    {
        console.log(COMP_NAME + ".ScrollAreaScrollEventHandler");

        let elmnt = e.target;

        let intScrollHeight = elmnt.scrollHeight; // scrollHeight Ref: https://www.w3schools.com/jsref/prop_element_scrollheight.asp
        let intScrollWidth = elmnt.scrollWidth; // scrollWidth
        let intScrollLeft = elmnt.scrollLeft; // scrollLeft
        let intScrollTop = elmnt.scrollTop; // scrollTop

        console.log("intScrollHeight:", intScrollHeight)
        console.log("intScrollWidth:", intScrollWidth)
        console.log("intScrollLeft:", intScrollLeft)
        console.log("intScrollTop:", intScrollTop)

        let intClientHeight = elmnt.clientHeight; // .divScrollArea 的高度 // clientHeight Ref: https://www.w3schools.com/jsref/prop_element_clientheight.asp
        let intClientWidth = elmnt.clientWidth; // clientWidth Ref: 
        let intClientTop = elmnt.clientTop; // clientTop
        let intClientLeft = elmnt.clientLeft; // clientLeft

        console.log("intClientHeight:", intClientHeight)
        console.log("intClientWidth:", intClientWidth)
        console.log("intClientTop:", intClientTop)
        console.log("intClientLeft:", intClientLeft)

        if (intScrollTop === 0)
        {
            console.log('Reached scroll div top')
        }

        // +1 是避免有小數點的誤差
        if (intScrollTop + intClientHeight + 1 >= intScrollHeight )
        {
            // 目前到最底 則切換 Top/Down圖示

            console.log('Reached scroll div bottom')
            setScrollButtonType(ScrollButtonEnum.Top)
        }
        else
        {
            setScrollButtonType(ScrollButtonEnum.More)
        }
    }

    // #region Scroll

    function ScrollToTop()
    {
        console.log(COMP_NAME + ".ScrollToTop: ")
        if (
            (typeof(mrefScrollArea.current) !== "undefined") &&
            (mrefScrollArea.current !== null)
        )
        {
            GlobalLibs.ExecuteScrollTo(mrefScrollArea.current, 0, 0, 0) // 回到最Top
        }

        setScrollButtonType(ScrollButtonEnum.More)
    }

    function SetScrollToTopOrMoreButton()
    {
        console.log(COMP_NAME + ".SetScrollToTopOrMoreButton: ");

        if (
            (typeof(mrefScrollArea.current) !== "undefined") &&
            (mrefScrollArea.current !== null)
            )
        {
            console.log("mrefScrollArea.current.scrollHeight: ", mrefScrollArea.current.scrollHeight)
            console.log("mrefScrollArea.current.clientHeight: ", mrefScrollArea.current.clientHeight)
            if (mrefScrollArea.current.scrollHeight === mrefScrollArea.current.clientHeight)
            {
                // 目前無Scroll的效果
                setShowScrollButton(false)
            }
            else
            {
                // 目前有Scroll的效果
                setShowScrollButton(true)
            }
        }
    }

    // #endregion Scroll

    function StopAudioAndResetPlayingIndex()
    {
        window.AudioLibs.StopAudio()
        setCurrentAudioPlayingIndex(INDEX_NONE)
    }

    // #endregion Other Functions

    // #region Get ClassName and Style
    function GetClsPageIcon(Index, CurrentIlluContentsIndex)
    {
        // console.log(COMP_NAME + ".GetClsPageIcon");
        // console.log("Index:", Index)
        // console.log("CurrentIlluContentsIndex:", CurrentIlluContentsIndex)

        let objCls = cssLanguageNotesVocabulary.divPageIconUnSelect

        if (Index === CurrentIlluContentsIndex)
        {
            objCls = cssLanguageNotesVocabulary.divPageIconSelected
        }

        return objCls
    }

    function GetClsPlayButton(SentenceIndex, StateCurrentAudioPlayingIndex, StatePlayMode)
    {
        // console.log(COMP_NAME + ".GetClsPlayButton", SentenceIndex, StateCurrentAudioPlayingIndex, StatePlayMode);

        let objCls = null

        if (SentenceIndex === StateCurrentAudioPlayingIndex)
        {
            if(StatePlayMode === PlayModeEnum.Loading)
            {
                objCls = cssLanguageNotesVocabulary.divListGridWrapperListPlayButtonLoading
            }
            else if(StatePlayMode === PlayModeEnum.Playing)
            {
                objCls = cssLanguageNotesVocabulary.divListGridWrapperListPlayButtonDisable
            }
        }
        else
        {
            objCls = cssLanguageNotesVocabulary.divListGridWrapperListPlayButtonEnable
        }

        return objCls
    }

    function GetClsScrollTopOrMoreButton(StateScrollButtonType)
    {
        // console.log(COMP_NAME + ".GetClsScrollTopOrMoreButton", StateScrollButtonType);

        let objCls = null

        if (StateScrollButtonType === ScrollButtonEnum.Top)
        {
            objCls = cssLanguageNotesVocabulary.divScrollAreaScrollButtonTop
        }
        else if (StateScrollButtonType === ScrollButtonEnum.More)
        {
            objCls = cssLanguageNotesVocabulary.divScrollAreaScrollButtonMore
        }

        return objCls
    }

    // #endregion Get ClassName and Style

    // #region Call App and AppCallback
    // #endregion Call App and AppCallback

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Component
    // #endregion Component

    // #region Render
    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssLanguageNotesVocabulary.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    }

    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea");

        let strTitleEN = props.SubSectionDef.Name;
        let strTitleCN = '';
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName;
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName;
        }

        let strInstruction = ""
        if (
            (typeof (props.LUInfo.Instruction) !== 'undefined') &&
            (props.LUInfo.Instruction !== null) &&
            (props.LUInfo.Instruction !== "")
            )
        {
            strInstruction = props.LUInfo.Instruction;
        }

        return (
            <>
                <div className={cssLanguageNotesVocabulary.divTitleLeftArea}>
                    {RenderGoogleClassrommButton()}
                    <div className={cssLanguageNotesVocabulary.divTitleSubArea}>
                        <div className={cssLanguageNotesVocabulary.divLessonIcon}></div>
                        <div className={cssLanguageNotesVocabulary.divLUTitleTextEN}>
                            {strTitleEN}
                        </div>
                        <div className={cssLanguageNotesVocabulary.divDividerBar}></div>
                        <div className={cssLanguageNotesVocabulary.divLUTitleTextCN}>
                            {strTitleCN}
                        </div>
                    </div>
                </div>
                <div className={cssLanguageNotesVocabulary.divTitleLeftInstructionArea}>{strInstruction}</div>
            </>
        )
    }

    function RenderHeaderRightArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderRightArea");

        return (
            <div className={cssLanguageNotesVocabulary.divTitleAreaRight}>{GetSubCategoryName(currentPageIndex)}</div>
        )
    }

    function RenderContentItem(SentenceIndex, StateCurrentPageIndex, SentenceItem)
    {
        return (
            <div key={SentenceIndex} className={cssLanguageNotesVocabulary.divListGridWrapper}>
                <div className={cssLanguageNotesVocabulary.divListGridWrapperNo}>{SentenceItem.No}</div>
                <div className={cssLanguageNotesVocabulary.divListGridWrapperListMajorOrMinorText}>{GetSubCategorySentenceText(StateCurrentPageIndex, SentenceIndex)}</div>
                <div className={GetClsPlayButton(SentenceIndex, currentAudioPlayingIndex, playMode)} onClick={() => PlayOneAudioOnTapHandler(StateCurrentPageIndex, SentenceIndex)}></div>
                <div className={cssLanguageNotesVocabulary.divListGridWrapperListPinyin}>{SentenceItem.Pinyin}</div>
                <div className={cssLanguageNotesVocabulary.divListGridWrapperListPartsOfSpeech}>{SentenceItem.Parts}</div>
                <div className={cssLanguageNotesVocabulary.divListGridWrapperListDefinition}>{SentenceItem.Def}</div>
            </div>
        )
    }

    function RenderCardContent()
    {
        // console.log(COMP_NAME + ".RenderCardContent")
        let objBlock = null
        if (props.LUInfo.SubCategory[currentPageIndex].Sentence !== null)
        {
            objBlock = props.LUInfo.SubCategory[currentPageIndex].Sentence.map((SentenceItem, SentenceIndex) =>
                RenderContentItem(SentenceIndex, currentPageIndex, SentenceItem))
        }

        return objBlock
    }

    function RenderContentListWrapper()
    {
        // console.log(COMP_NAME + ".RenderContentListWrapper")
        console.log("currentPageIndex: ", currentPageIndex)

        let objBlock = null
        if(props.LUInfo.SubCategory.length > 1)
        {
            objBlock = (
                <Card
                    CardIndex={currentPageIndex}
                    ChangeAnimationType={mintChangeAnimationType}
                    CardBackground={CardBackgroundEnum.Default}
                    CallbackRef={CardCallback}
                    RenderContent={RenderCardContent()}
                />
            )
        }
        else if (props.LUInfo.SubCategory === 1)
        {
            objBlock = RenderCardContent()
        }

        return objBlock
    }

    function RenderContentListHeader()
    {
        // console.log(COMP_NAME + ".RenderContentListHeader")
        return (
            <div className={cssLanguageNotesVocabulary.divContentHeader}>
                <div className={cssLanguageNotesVocabulary.divContentHeaderNo}>{window.gAppUI.LBL_No}</div>
                <div className={cssLanguageNotesVocabulary.divContentHeaderChinese}>{window.gAppUI.LBL_Chinese}</div>
                <div className={cssLanguageNotesVocabulary.divContentHeaderPinyin}>{window.gAppUI.LBL_Pinyin}</div>
                <div className={cssLanguageNotesVocabulary.divContentHeaderPartsOfSpeech}>{window.gAppUI.LBL_PartsOfSpeech}</div>
                <div className={cssLanguageNotesVocabulary.divContentHeaderDefinition}>{window.gAppUI.LBL_Definition}</div>
            </div>
        )
    }

    function RenderContentScrollArea()
    {
        console.log(COMP_NAME + ".RenderContentScrollArea: ")
        return (
            <div ref={mrefScrollArea} className={cssLanguageNotesVocabulary.divScrollArea} onScroll={(event) => ScrollAreaScrollEventHandler(event)}>
                {RenderContentListWrapper()}
            </div>
        )
    }

    function RenderScrollTopOrMoreButton()
    {
        console.log(COMP_NAME + ".RenderScrollTopOrMoreButton: ", showScrollButton)
        let objBlock = null
        if(showScrollButton)
        {
            objBlock = (
                <div className={GetClsScrollTopOrMoreButton(scrollButtonType)} onClick={() => ScrollAreaScrollToTopOrMoreOnTapHandler()}></div>
            )
        }
        return objBlock
    }

    function RenderContentArea()
    {
        // console.log(COMP_NAME + ".RenderContentArea")
        return (
            <div className={cssLanguageNotesVocabulary.divContentArea}>
                {RenderContentListHeader()}
                {RenderContentScrollArea()}
                {RenderScrollTopOrMoreButton()}
            </div>
        )
    }

    function RenderPageIconArea()
    {
        // console.log(COMP_NAME + ".RenderPageIconArea")
        let objBlock = null
        if (props.LUInfo.SubCategory.length > 1)
        {
            // 顯示頁碼
            objBlock = (
                <div className={cssLanguageNotesVocabulary.divPageIconArea}>
                    <div className={cssLanguageNotesVocabulary.divPageIconContainer}>
                        {props.LUInfo.SubCategory.map((SubCategoryItem, SubCategoryIndex) =>
                            <div key={SubCategoryIndex} className={cssLanguageNotesVocabulary.divPageIconBlock}>
                                <div className={GetClsPageIcon(SubCategoryIndex, currentPageIndex)}></div>
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        return objBlock
    }

    return (
        <>
            {RenderHeaderLeftArea()}
            {RenderHeaderRightArea()}
            {RenderContentArea()}
            {RenderPageIconArea()}
        </>
    )
    // #endregion Render
}
export default LanguageNotesVocabulary